import script from "./MediaCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaCarousel.vue?vue&type=script&setup=true&lang=js"

import "./MediaCarousel.vue?vue&type=style&index=0&id=2df88db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df88db8"]])

export default __exports__